import React, { useState } from 'react';
import axios from 'axios';
import useStore from '../useStore';
import { Container, Row, Col, Table, Form, Button } from "react-bootstrap";

function LoadingIndicator() {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <div className="loading-label">Loading</div>
    </div>
  );
}

function AdminPortal() {
  const [formData, setFormData] = useState({
    agencyName: "",
    desigCode: ""
  });

  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { selectedAgency, setSelectedAgency } = useStore();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const isSearchEnabled = Object.values(formData).some((val) => val.trim() !== "");

  const handleSearch = async () => {
    if (!isSearchEnabled) return;

    setLoading(true);
    setError(false);
    try {
      const params = new URLSearchParams({
        name: formData.agencyName.trim() || "",
        desig: formData.desigCode.trim() || ""
      });

      const apiUrl = `${process.env.REACT_APP_API_URL}/Agency?${params.toString()}`;
      const response = await axios.get(apiUrl);

      let results = response.data;

      // ✅ Handle both array and single object responses
      if (!Array.isArray(results)) {
        results = [results];
      }

      const sortedAgencies = results.sort((a, b) => a.name.localeCompare(b.name));
      setAgencies(sortedAgencies);

    } catch (error) {
      console.error("Error fetching agencies:", error);
      setError(true);
      setAgencies([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingIndicator />;

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8}>
          <div style={{ backgroundColor: "#f8f9fa", padding: "30px", borderRadius: "10px", boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
            <h2 style={{ marginBottom: "20px" }}>Search for Agencies</h2>
            <Form>
              <Form.Group controlId="agencyName" style={{ marginBottom: "15px" }}>
                <Form.Label>Agency Name</Form.Label>
                <Form.Control
                  type="text"
                  name="agencyName"
                  value={formData.agencyName}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="desig" style={{ marginBottom: "15px" }}>
                <Form.Label>Desig Code</Form.Label>
                <Form.Control
                  type="text"
                  name="desigCode"
                  value={formData.desigCode}
                  onChange={handleChange}
                />
              </Form.Group>

              <Button
                variant="primary"
                onClick={handleSearch}
                disabled={!isSearchEnabled || loading}
              >
                {loading ? "Searching..." : "Search"}
              </Button>
            </Form>
          </div>

          {error && (
            <div style={{ color: "red", marginTop: "15px" }}>
              <strong>Error loading agency. Please check your API connection.</strong>
            </div>
          )}

          {agencies.length > 0 && !error && (
            <div style={{ marginTop: "20px" }}>
              <h3>Results</h3>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Agency Name</th>
                    <th>Desig Code</th>
                    <th>Agency Email</th>
                  </tr>
                </thead>
                <tbody>
                  {agencies.map((agency, index) => (
                    <tr
                      key={index}
                      onClick={() => setSelectedAgency(agency)}
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          selectedAgency?.vendorId === agency.vendorId ? "#e0f3ff" : "white",
                      }}
                    >
                      <td>{agency.name}</td>
                      <td>{agency.vendorId}</td>
                      <td>{agency.agencyEmail}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {selectedAgency && (
                <div style={{ marginTop: "15px", padding: "10px", background: "#f1f1f1", borderRadius: "5px" }}>
                  <strong>Selected Agency:</strong> {selectedAgency.name} ({selectedAgency.vendorId})
                </div>
              )}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default AdminPortal;
